import { Head } from "@inertiajs/react";

import { PbrainShell } from "@/components/pbrain-shell";
import type { ProjectListItem, DeveloperListItem } from "@/lib/api";
import type { SharedProps } from "@/lib/types";

type DashboardProps = SharedProps & {
  projects: ProjectListItem[];
  developers: DeveloperListItem[];
};

export default function DashboardIndex(props: DashboardProps) {
  return (
    <>
      <Head title="Dashboard" />
      <PbrainShell {...props} />
    </>
  );
}
